import { extend } from 'vee-validate';

extend('alphanumeric_hyphen_underbar', {
  validate: (value) => {
    return {
      required: true,
      // Only alphabets and numeric
      valid: /^[a-zA-Z0-9-_]+$/.test(value),
    };
  },
  computesRequired: true,
});
